import styled from "styled-components";

export const CMHeadingContainer = styled.div(props => ({
  display: 'flex',
  width:"100%",

  '& nav': {
    width: 'fit-content',
    minWidth: '400px',
    display: 'flex',
    padding: '1rem 5vw 8px 0',
    borderBottom: `solid 1px ${props.theme.palette.primary.main}`,

    '& a': {
      fontWeight: 500,
      textDecoration: 'none',
      fontSize: props.theme.fontSizes.h3,
      color: props.theme.palette.primary.main,
      fontFamily: props.theme.fontFamilies.workSans,

      '&.current': {
        color: props.theme.palette.dark['900'],
      },
    },

    '@media (max-width: 992px)': {
      marginTop: '2em',
      marginBottom: '1em',
      minWidth: '135%',
    },

    '@media (max-width: 767px)': {
      minWidth: '100%',
    },

    '@media (max-width: 1023px)': {
      margin: '0',
      paddingBottom: '10px',
      minWidth: '90%!important',
    },
  },

    [`@media (min-width: 2000px)`]: {
      '& nav': {
        width: '100%',
        minWidth: 'unset',
        '& a': {
          fontSize: '3vh !important',
        },
      },
    },
    
    [`@media${props.theme.breakpoints.lg}`]: {
        marginBottom: "2%",
        marginLeft: "2%",
        '& nav': {
            width: '90%',
            minWidth: 'unset',
            '& a': {
                fontSize: '24px',
            }
        }
    },

    [`@media${props.theme.breakpoints.sm}`]: {
        '& nav': {
            //padding: '2em 0 0'
        }
    },

    [`@media ${props.theme.breakpoints.xs}`]: {
      '& nav': {
        //padding: '0',
        '& a': {
          fontSize: '20px',
        },
      },
    },

    [`@media${props.theme.breakpoints.xss}`]: {
        '& nav': {            
            '& a': {
                fontSize: '16px',
            }
        }
    }
}));
